import { styled as muiStyled } from '@mui/material'

export const TimerPageContainer = muiStyled('div')(
  ({ theme, bgImgUrl }) => `
    background-image: url("${bgImgUrl}");
    background-size: cover;
      background-position: center;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
`,
)
